import { Component, OnInit, ContentChildren, QueryList, AfterContentInit, ViewChild,OnChanges, ElementRef, ViewContainerRef, Input, Renderer2, ViewChildren, Output, EventEmitter } from '@angular/core';
import { SwTabComponent } from './sw-tab/sw-tab.component';

/**
 * 选项卡组件
 * 研发二组 ZR
 * 
 * @export
 * @class SwTabsetComponent
 * @implements {OnInit}
 * @implements {AfterContentInit}
 */
@Component({
  selector: 'sw-tabset',
  templateUrl: './sw-tabset.component.html',
  styleUrls: ['./sw-tabset.component.css']
})
export class SwTabsetComponent implements OnInit,AfterContentInit,OnChanges {

  @ContentChildren(SwTabComponent) TabComponentList !: QueryList<SwTabComponent>;
  @ViewChild('tabContent') tabContent:ElementRef;
  @ViewChild('swTabset') swTabset:ElementRef;
  

  // 选项卡标题（极少使用）
  @Input()
  title:string = "";

  // 当前选中项
  @Input()
  currentIndex:number=0;


  // 样式状态
  @Input()
  styleStutas:number = 3;

  // 选项卡状态改变
  @Output()
  tabChange = new EventEmitter;

  // 选项卡各项标题数组
  tabTitleList:Array<any> = [];
  
  // 选项卡各项内容区元素数组，从投影中获取
  tabSlideList:Array<any> = [];

  constructor(
    private renderer2:Renderer2
  ) { }
  ngOnChanges(){
  }
  ngOnInit() {
    this.renderer2.addClass(this.swTabset.nativeElement,'status'+this.styleStutas);
  }

  /**
   * 加载投影后的节点
   * 
   * @memberof SwTabsetComponent
   */
  ngAfterContentInit(){
    this.TabComponentList.map((item,index)=>{
      this.tabTitleList.push({"title":item.title,"disabled":item.disabled});
      this.tabSlideList.push(item.tabTpl.nativeElement);
    })
    this.initContent();
  } 
  /**
   * 选项卡内容区初始化
   * 
   * @memberof SwTabsetComponent
   */
  initContent(){
    this.checkTab(this.currentIndex);
  }
  /**
   * 选项卡切换点击事件
   * 
   * @param {any} index 当前点击项下标
   * @memberof SwTabsetComponent
   */
  tabClick(index, disabled){
    if(disabled){
      return;
    }
    if(index != this.currentIndex){
      this.currentIndex = index;
      this.tabChange.emit(index);
      this.checkTab(this.currentIndex);
    }
  }
  /**
   * 选中第index项
   * 
   * @param {any} index 选项卡下标
   * @memberof TabsetComponent
   */
  checkTab(index){
    // 通过设置包裹块的margin-left属性，将当前项显示在可视区域
    this.renderer2.setStyle(this.tabContent.nativeElement,'marginLeft',-index*100+'%');
    this.tabSlideList.map((item,index)=>{
      if(this.currentIndex!=index){
        this.renderer2.setStyle(item,'height',0);
      }else{
        this.renderer2.setStyle(item,'height','auto');
        
      }
    })
  }
}
